// import { colours } from "orcs-design-system";
import styled, { keyframes } from "styled-components";

import { circleGradient, lineGradient } from "./placeholderGradients";

/* Infinite Rotation */
export const COLOR_CHANGE = keyframes`
0% {
  background-position: -468px 0;
}
100% {
  background-position: 468px 0;
}
`;

// Use for placeholder circles
// add props as neccessary
export const Circle = styled.div`
  justify-self: center;
  width: ${({ width }) => `${width || 36}px`};
  height: ${({ height }) => `${height || 36}px`};
  background-size: 200px;
  border-radius: 50%;
  background: ${({ theme }) => circleGradient(theme)};
  animation: ${COLOR_CHANGE} 20s linear infinite;
`;

// use for placeholder lines
// add props as neccessary
export const Line = styled.div`
  width: 100px;
  border-radius: 8px;
  animation-delay: 0.2s;
  background: ${({ theme }) => lineGradient(theme)};
  animation: ${COLOR_CHANGE} ${({ animationSpeed = "10s" }) => animationSpeed}
    linear both infinite;
  height: ${({ height }) => `${height}px`};
  width: ${({ width }) => `${width}px`};
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : "0px")};
`;
